module.exports = __webpack_public_path__ + "img/ctrl-rz-stub-+.8455568b.svg";